import { mapState } from 'vuex';
import searchMixin from '@/mixins/search';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import infiniteLoading from 'vue-infinite-loading';
import { BRAND } from '@/components/brand-name/brand-name.js';

export default {
  mixins: [
    searchMixin,
  ],
  components: {
    infiniteLoading,
    marketListItem: marketListItemV2,
  },
  metaInfo() {
    return {
      title: `${BRAND}: Search Results`,
    };
  },
  data() {
    return {
      infiniteLoader: null,
    };
  },
  computed: {
    ...mapState('search', ['hasSearched', 'searchResults', 'searchQuery']),
    items() {
      return this.searchResults.data === null ? [] : this.searchResults.data;
    },
  },
  watch: {
    items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.searchResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    },
  },
  methods: {
    goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.searchResults.canLoadMore) {
        const query = this.$router.currentRoute.query.query;
        this.doSearch(query, { reset: false });
      }
    },
  },
  created() {
    const query = this.$router.currentRoute.query.query;
    // no search results in store and query provided
    // so user must have navigated here manually, trying searching
    if (!this.hasSearched && query) {
      this.doSearch(query);
    }
  },
  beforeDestroy() {
    this.resetSearchResults('');
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-search/page-search.js